const M = (n, r, o, a) => {
  const { selection: k } = r, { from: i, to: h } = k, f = [];
  return r.doc.nodesBetween(i, h, (t, s) => {
    t.isText && t.marks.forEach((e) => {
      e.type.name === "textStyle" && e.attrs[n] && f.push({ mark: e, pos: s, size: t.nodeSize });
    });
  }), f.forEach(({ mark: t, pos: s, size: e }) => {
    const l = { ...t.attrs, [n]: null }, m = Math.max(i, s), u = Math.min(h, s + e);
    if (o.removeMark(m, u, t.type), Object.entries(l).some(
      ([c, x]) => c !== n && x !== null && x !== void 0
    )) {
      const c = r.schema.marks.textStyle.create(l);
      o.addMark(m, u, c);
    }
  }), a && a(o), !0;
};
export {
  M as unsetTextStyleAttribute
};
